import React, {
  ReactElement,
  Fragment,
} from 'react';
import {IconButton} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import Popover from '@mui/material/Popover';
import {RestoreFromTrashRounded} from "@mui/icons-material";
import {hasPermissionByPriority} from "../../../core/permissions/hasPermission";
import {ROLE_PRIORITIES} from "../../../core/permissions/permissions";
import {useStateContext} from "../../../hooks/useStateContext";

export const MoreOptions = ({
                              clickOnEdit,
                              clickOnDelete,
                              disabledDelete,
                              disabledEdit,
                              clickOnRestore,
                              hideEdit,
                            }: {
  clickOnEdit: () => void;
  clickOnDelete: () => void;
  clickOnRestore?: () => void;
  disabledDelete?: boolean;
  disabledEdit?: boolean;
  hideEdit?: boolean;
}): ReactElement => {


  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const {user} = useStateContext();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const canDelete = hasPermissionByPriority(user.roles, ROLE_PRIORITIES[1]);


  return (
    <>
      <IconButton
        size={'small'}
        aria-label="more options"
        color={'default'}
        onClick={handleClick}
      >
        <MoreVertIcon/>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        onClick={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {!hideEdit && (
          <IconButton
            disabled={disabledEdit || !!clickOnRestore}
            size={'small'}
            color={'primary'}
            aria-label="edit"
            onClick={() => {
              clickOnEdit();
            }}
          >
            <EditIcon/>
          </IconButton>
        )}
        <IconButton
          disabled={disabledDelete || !!clickOnRestore}
          size={'small'}
          aria-label="delete"
          onClick={() => {
            clickOnDelete();
          }}
          color={'error'}
        >
          <DeleteIcon/>
        </IconButton>

        {clickOnRestore && (
          <IconButton
            size={'small'}
            aria-label="restore"
            onClick={() => {
              clickOnRestore();
            }}
            color={'primary'}
          >
            <RestoreFromTrashRounded />
          </IconButton>
        )}
      </Popover>
    </>
  );
};
